<template>
	<div class="suppliers">
		<v-btn small fab class="mb-3" color="primary" @click="showNewSupplierForm = !showNewSupplierForm">
			<v-icon>mdi-plus</v-icon>
		</v-btn>
		<v-row v-if="showNewSupplierForm" no-gutters>
			<v-col cols="12" sm="6">
				<v-form ref="newSupplierForm" v-model="validSupplier">
					<v-text-field
						v-model="newSupplierName"
						:label="$gettext('Supplier Name')"
						outlined
						class="px-2"
						:rules="[required]"
					></v-text-field>
				</v-form>
			</v-col>
			<v-col cols="12" sm="6">
				<v-btn color="primary" class="mt-3" @click="addSupplier">
					<translate>Add</translate>
				</v-btn>
			</v-col>
		</v-row>
		<v-list flat>
			<v-list-item
				v-for="supplier in suppliers"
				:key="supplier.id"
				style="border: 1px solid #e0e0e0; border-radius: 5px"
				color="primary"
			>
				<v-list-item-icon class="mr-3">
					<v-icon color="primary">store</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title>{{supplier.name}}</v-list-item-title>
				</v-list-item-content>
				<v-list-item-action class="primary--text">
					<v-row no-gutters align="center">
						<v-switch @change="editSupplier(supplier)" v-model="supplier.verified" key="verified" color="primary" label="Verificado"></v-switch>
						<v-switch @change="editSupplier(supplier)" v-model="supplier.active" key="active" color="primary" label="Ativo"></v-switch>
						<v-btn class="ml-3" icon @click="supplierEdited = supplier; showEditSupplier = true">
							<v-icon color="primary">mdi-pencil</v-icon>
						</v-btn>
						<v-btn class="ml-1" icon @click="supplierToDelete = supplier; showDeleteSupplier = true">
							<v-icon color="primary">mdi-delete</v-icon>
						</v-btn>
					</v-row>
				</v-list-item-action>
			</v-list-item>
		</v-list>
		<v-dialog v-model="showEditSupplier" max-width="40%">
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Edit Supplier</translate>
				</v-card-title>
				<v-card-text class="pt-2">
					<v-text-field
						v-model="supplierEdited.name"
						:label="$gettext('Supplier Name')"
						outlined
						class="px-2"
						:rules="[required]"
					></v-text-field>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="primary darken-1" text @click="showEditSupplier = false">
						<translate key="close">Close</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="editSupplier(supplierEdited)">
						<translate key="save">Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="showError" max-width="40%">
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Error</translate>
				</v-card-title>
				<v-card-text
					class="pt-2"
				>Não foi possível remover o fornecedor, este tem produtos a si associados!</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showError = false">
						<translate key="close">Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<DeleteConfirmationDialog v-model="showDeleteSupplier" item="supplier" @delete="deleteSupplier(supplierToDelete)" />
	</div>
</template>

<script>
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import axios from "axios";

export default {
	name: "Suppliers",
	props: ["suppliers"],
	components: {
		DeleteConfirmationDialog
	},
	data: () => ({
		showNewSupplierForm: false,
		newSupplierName: "",
		showEditSupplier: false,
		validSupplier: false,
		supplierEdited: {},
		showDeleteSupplier: false,
		supplierToDelete: {},
		showError: false
	}),
	computed: {
		required() {
			return value => !!value || this.$gettext("Required.");
		}
	},
	methods: {
		addSupplier() {
			if (this.$refs.newSupplierForm.validate()) {
				const form = new FormData();
				form.append("name", this.newSupplierName);
				axios
					.post("/admin/providers/new", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
							this.suppliers.push(response.data.provider);
							this.newSupplierName = "";
							this.showNewSupplierForm = false;
						}
					})
					.catch(error => console.log(error));
			}
		},
		editSupplier(supplier) {
			axios
				.post("/admin/providers/" + supplier.id + "/edit", supplier)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "ok") this.showEditSupplier = false;
				})
				.catch(error => console.log(error));
		},
		deleteSupplier(supplier) {
			axios
				.post("/admin/providers/" + supplier.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted"){
						this.suppliers.splice(this.suppliers.indexOf(supplier), 1);
						this.showDeleteSupplier = false;
					}
					else {
						this.showDeleteSupplier = false;
						this.showError = true;
					}
				})
				.catch(error => console.log(error));
		}
	}
};
</script>